import {doFetchWithRedirect} from "./doFetchWithRedirect";

const defaultHeaders = {
  "Content-Type": "application/json",
  "Cache-Control": "no-cache"
}; // expect to receive JSON

export async function tryDoFetchWithRedirect(url, body, method = "POST", headers = defaultHeaders, onError) {
  try {
    return await doFetchWithRedirect(url, body, method, headers);
  } catch (err) {
    console.error("Fetch exception: ", { name: err?.toString(), body, method, url });
    if (onError) onError(err);
  }
}
